module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "notice notice-warm m1111"
  }, [_vm._v("\n    本例需要在手机下查看\n  ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7316ef7a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/list/demo.vue
// module id = 266
// module chunks = 8